<template>
  <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
    <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
      <el-form-item
        :label="$t('public.table_scope')"
        prop="sceneId"
        v-if="sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin'"
      >
        <el-select v-model="dioForm.sceneId" style="width: 250px">
          <el-option
            v-for="item in scopeArrays"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item :label="$t('integration.gateway_name_')" prop="name">
          <el-input v-model.trim="dioForm.name" style="width: 250px" maxlength="20"
              :placeholder="$t('public.please_enter')" />
      </el-form-item> -->
      <el-form-item :label="$t('device.gateway_type')" prop="type">
        <el-select v-model="dioForm.type" style="width: 250px">
          <el-option
            v-for="item in deviceGateWayType"
            :key="item.value"
            :label="`${$t(deviceTypeListConvert[item.code])}`"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('device.gateway_mac')" prop="mac">
        <el-input
          v-model.trim="dioForm.mac"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
      </el-form-item>
      <el-form-item :label="$t('device.gateway_serial_num')" prop="sn">
        <el-input
          v-model.trim="dioForm.sn"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
      </el-form-item>
      <el-form-item :label="$t('device.gateway_nickname')" prop="nickname">
        <el-input
          v-model.trim="dioForm.nickname"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
      </el-form-item>
      <template v-if="netParamShow">
        <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
          <el-input
            v-model.trim="dioForm.extPanId"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
        <el-form-item :label="$t('Join Attemp')" prop="channelPage">
          <el-input
            v-model.trim="dioForm.channelPage"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
        <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
          <el-input
            v-model.trim="dioForm.channelMask"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
      </template>

      <!-- 二代网关属性设置 -->
      <template v-else>
        <el-form-item :label="$t('integration.alarm_switch')" prop="alarmSwitch">
          <el-checkbox
            :true-label="1"
            :false-label="0"
            v-model="dioForm.alarmSwitch"
          ></el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('integration.alarm_volume_')">
          <div style="width: 250px;margin-top: -5px;">
            <el-slider
              show-stops
              :step="1"
              :min="1"
              :max="10"
              v-model="dioForm.alarmVoiceSize"
            ></el-slider>
          </div>
        </el-form-item>
        <el-form-item :label="$t('integration.alarm_time_(seconds)')">
          <el-input
            style="width: 250px"
            v-model="dioForm.alarmTimeSize"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('integration.alarm_interval_(seconds)')">
          <el-input
            style="width: 250px"
            v-model="dioForm.alarmIntervalTime"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('integration.number_of_alarms')">
          <el-input style="width: 250px" v-model="dioForm.alarmSize"></el-input>
        </el-form-item>
        <el-form-item :label="$t('integration.number_of_labels_per_page')">
          <el-select style="width: 250px" v-model="dioForm.tagSize">
            <el-option
              :value="key"
              :label="$t(item.title)"
              v-for="(item, key) in gateway02TagSize"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item :label="$t('public.table_desc')" prop="description">
        <el-input
          v-model.trim="dioForm.description"
          style="width: 250px"
          type="textarea"
          maxlength="250"
          :autosize="{ minRows: 2, maxRows: 4 }"
          show-word-limit
          :placeholder="$t('public.please_enter')"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false">{{
        $t('public.btn_close')
      }}</el-button>
      <el-button type="primary" @click="handleSave">{{
        $t('public.btn_confirm')
      }}</el-button>
    </div>
  </modal>
</template>

<script>
import { getAddGateway, getEditGateway } from '@/api/modules/gateway.js'
import { defaultAttrGateway02, defaultNetParams } from '../config/default'
import { gateway02TagSize, deviceTypeListConvert } from '@/utils/convert'

export default {
  props: ['isShow', 'title', 'scopeArray', 'editRow', 'deviceGateWayType'],
  watch: {
    scopeArray (newVal) {
      this.scopeArrays = [...newVal]
    },
    editRow: {
      handler (newVal) {
        if (!newVal) return
        console.log('watch editRow -> ', newVal)
        console.log('watch editRow.mac -> ', newVal.mac)
        this.dioForm = {
          sceneId: String(newVal.sceneId),
          mac: newVal.mac,
          type: newVal.type,
          typeCode: newVal.typeCode,
          sn: newVal.sn,
          nickname: newVal.nickname,
          id: newVal.id,
          description: newVal.description,
          channelMask: newVal.channelMask,
          extPanId: newVal.extPanId,
          channelPage: newVal.channelPage,
          alarmIntervalTime: newVal.alarmIntervalTime,
          alarmSize: newVal.alarmSize,
          alarmSwitch: newVal.alarmSwitch != null ? Number(newVal.alarmSwitch) : undefined,
          alarmTimeSize: newVal.alarmTimeSize,
          alarmVoiceSize: newVal.alarmVoiceSize,
          tagSize: newVal.tagSize,
        }
        console.log('form -> ',this.dioForm)
        console.log('form.mac -> ', this.dioForm.mac)
      },
      immediate: true,
      deep: true
    },
    'dioForm.type': {
      handler () {
        // 设备类型是二代网关  隐藏掉网络参数并删除  设置二代网关属性
        if (this.dioForm.type === 3) {
          this.netParamShow = false
          this.dioForm.channelMask = undefined
          this.dioForm.extPanId = undefined
          this.dioForm.channelPage = undefined
          // 将其设置为响应式数据
          const camelCaseKeyMap = {
            alarmSwitch: 'alarmSwitch',
            alarmVoiceSize: 'alarmVoiceSize',
            alarmTimeSize: 'alarmTimeSize',
            alarmIntervalTime: 'alarmIntervalTime',
            alarmSize: 'alarmSize'
          }
          Object.keys(defaultAttrGateway02).forEach(key => {
            const camelKey = camelCaseKeyMap[key] || key
            if (this.dioForm[camelKey] === undefined || this.dioForm[camelKey] === null) {
              this.$set(this.dioForm, camelKey, camelKey === 'alarmSwitch' ? Number(defaultAttrGateway02[key]) : defaultAttrGateway02[key])
            }
          })
        } else {
          Object.keys(defaultNetParams).forEach(key => {
            if (this.dioForm[key] === undefined) {
              this.$set(this.dioForm, key, defaultNetParams[key])
            }
          })

          this.netParamShow = true
        }
      }
    }
  },
  computed: {
    deviceTypeListConvert: () => deviceTypeListConvert,

    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if (
        (!currentUser.sysScope && currentUser.scopeAdmin) ||
        currentUser.type === 2
      ) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    },
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    rules () {
      const channelMask = function (rules, value, callback) {
        const reg = /^\d+([,]\d+)*$/
        if (!reg.test(String(value))) {
          callback(
            new Error(
              $t(
                'integration.multiple_combined_numbers_are_separated_by_commas_and_are_numbers'
              )
            )
          )
        } else {
          const array = value.split(',')
          for (const item of array) {
            if (parseInt(item) > 255 || parseInt(item) < 1) {
              callback('存在不在1-255范围的值')
            }
          }
          callback()
        }
      }
      return {
        name: [
          {
            required: true,
            message: $t('integration.please_enter_the_gateway_name')
          }
        ],
        sceneId: [
          {
            required: true,
            message: $t('integration.range_cannot_be_empty'),
            trigger: 'change'
          }
        ],
        mac: [
          {
            required: true,
            message: $t('integration.mac_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 30,
            message: $t('integration.the_mac_length_cannot_be_greater_than_30'),
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: $t('integration.gateway_type_cannot_be_empty'),
            trigger: 'change'
          }
        ],
        sn: [
          {
            required: true,
            message: $t('integration.gateway_serial_number_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 50,
            message: $t('integration.the_mac_length_cannot_be_greater_than_50'),
            trigger: 'blur'
          }
        ],
        nickname: [
          {
            required: true,
            message: $t('integration.gateway_nickname_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 30,
            message: $t('integration.the_mac_length_cannot_be_greater_than_30'),
            trigger: 'blur'
          }
        ],
        extPanId: [
          {
            required: true,
            message: 'Ext Pan ID' + $t('integration.cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 18,
            message: $t(
              'integration.the_length_is_8_hex_bases_c__i_dot_e_dot__18'
            ),
            trigger: 'blur'
          },
          {
            validator: this.$fromRules.FormValidate.Form().Code,
            trigger: 'blur'
          }
        ],
        channelPage: [
          {
            required: true,
            message: 'Join Attemp' + $t('integration.cannot_be_empty'),
            trigger: 'blur'
          },
          {
            validator: this.$fromRules.FormValidate.maxMinFn('channelPage')
              .netRule,
            trigger: 'blur'
          }
        ],
        channelMask: [
          {
            required: true,
            message: $t('integration.channel_mask_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            validator: channelMask,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  data () {
    return {
      dioForm: {
        name: '',
        sceneId: '',
        mac: '',
        type: '',
        typeCode: '',
        sn: '',
        nickname: '',
        // 默认网络参数
        ...defaultNetParams,
        description: ''
      },
      scopeArrays: [],
      // 是否展示网络参数 因为二代网关是没有网络参数的
      netParamShow: true,
      gateway02TagSize
    }
  },
  methods: {
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      let httpUrl = getAddGateway
      if (this.dioForm.id) {
        httpUrl = getEditGateway
      } else {
        delete this.dioForm.id
        for (const item of this.deviceGateWayType) {
          if (this.dioForm.type === Number(item.value)) {
            this.dioForm.typeCode = item.code
            break
          }
        }
      }
      this.dioForm.sceneId =
        this.dioForm.sceneId || this.$store.state.userInfo.scope.sceneId
      httpUrl(this.dioForm).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success(
            this.dioForm.id
              ? this.$t('public.tip_edit_succ')
              : this.$t('public.tip_add_succ')
          )
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  border-radius: 2px;
  margin-left: 5px;
}
</style>
